export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Premium Bank",
  headLine: "Unlimited Transaction with zero fees",
  description:
    "Get access to our exclusive app tha allows you to send unlimited transaction without getting charged any fees.",
  buttonLabel: "Get started",
  imgStart: false,
  img: require("../../images/svg-2.svg"),
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Unlimited Access",
  headLine: "Login yo your account at any time",
  description:
    "We have you covered no matter where are you located. All you need is an internet connection and a phone or computer.",
  buttonLabel: "Learn More",
  imgStart: true,
  img: require("../../images/svg-3.svg"),
  alt: "Car",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Join our team",
  headLine: "Creating an account is extreamly easy",
  description:
    "Get everything set up and ready in under 10 minutes. All you need to do is add your information and you're ready to go.",
  buttonLabel: "Start Now",
  imgStart: true,
  img: require("../../images/svg-4.svg"),
  alt: "Papers",
  dark: false,
  primary: false,
  darkText: true,
};
